<template>
<div >

	<Navbar></Navbar>
	<div class="main-content">
		<Loader :show="loading"></Loader>
		<div class="container" v-if="!loading">
			
			<div class="card mt-2">
				<div class="card-body">
		
					<div class="page-header">
						<ol class="breadcrumb">
							<li class="breadcrumb-item">GENERAL</li>
							<li class="breadcrumb-item active">Controles</li>
						</ol>
						<div class="title">
							<h1>Controles</h1>
						</div>
						<div class="cta">
							
						</div>
					</div>

						
					<div class="filters-box">
						<div class="filter">
							<label>BUSCAR</label>
							<input 
								type="text" 
								class="form-control" 
								placeholder="Buscar" 
								v-model="filters.search" 
								@keyup.enter="updateFilters($event)">
						</div>
						<div class="filter">
							<label>Tipo</label>
							<select class="form-control" 
								v-model="filters.type" 
								@change="updateFilters($event)">
								<option value="">Todos</option>
								<option value="ADMISSION">Ingresos</option>
								<option value="PRE_DELIVERY">Pre entregas</option>
								<option value="MOVE_CAR">Cambio de lugar</option>
								<option value="DISPATCH">Despachos</option>
								<option value="DELIVERY">Entregas</option>
							</select>
						</div>
						<div class="filter">
							<label>Fecha</label>
							<date-picker range
								v-model="filters.dates" 
								:value-type="'YYYY-MM-DD'"
								:format="'DD-MM-YYYY'"
								@change="updateFilters()"
							></date-picker>
						</div>
						<div class="filter">
							<label>Usuario</label>
							<select class="form-control" 
								v-model="filters.user" 
								@change="updateFilters($event)">
								<option value="">Todos</option>
								<option :value="user.id" v-for="user in users" :key="user.id">{{user.name}}</option>
							</select>
						</div>
					</div>

					<table class="table ">
						<tr class="table-head">
							<td>Control</td>
							<td>Vehículo</td>
							<td>Usuario</td>
						</tr>
						
						<tr v-for="item of list" :key="item.id" @click="openPreview(item.id)" >
							<td>
								<div class="tc">
									<span class="text-primary">{{item.typeText}}</span>
									<span >{{item.created_at | moment("DD-MM-YYYY HH:mm")}}</span>
								</div>
							</td>
							<td>
								<div class="tc">
									<span >{{item.car.brand.title}} {{item.car.model}}</span>
									<span class="text-primary">{{item.car.chassis_number}}</span>
								</div>
							</td>
							<td>
								<div class="tc">
									<span class="text-primary">{{item.user.name}}</span>
									<!-- <span >{{item.model}}</span> -->
								</div>
							</td>
						</tr>
						
					</table>

					<div class="alert alert-info text-center" v-if="list.length==0" >No se han encontrado controles</div>
					
					<vue-ads-pagination v-if="pagination"
						:total-items="pagination.total"
						:max-visible-pages="2"
						:items-per-page="pagination.length"
						:page="pagination.page-1"
						@page-change="pageChange"					
					></vue-ads-pagination>
				</div>
			</div>
		</div>
	</div>

	<ControlPreview ref="controlPreview"></ControlPreview>

</div>
</template>

<script>
import gql from 'graphql-tag'
import listMixins from '@/mixins/listMixins'

import Navbar from '@/components/Navbar'
import Loader from '@/components/Loader'
import ControlPreview from '@/views/controls/ControlPreview'

export default {
	name: 'controls',
	components:{
		Navbar,
		Loader,
		ControlPreview
	},
	mixins:[listMixins],
	data () {
		return {
			list:[],
			loading: true,
			users:[]
		}
	},
	beforeMount(){
		this.filters = this.getValidUrlParams();
		this.load();
	},
	methods:{
		load(){
			this.$apollo.query({
				query: gql`query ($first: Int!, $page: Int, $search: String, $type: String, $dates:[Date], $user: ID) {
					controls(first: $first, page: $page, search: $search, type: $type, dates: $dates, user: $user) {
						paginatorInfo {
							count
							currentPage
							total
						}
						data {
							id
							typeText
							user{
								name
							}
							car{
								chassis_number
								model
								brand{
									title
								}
							}
							created_at
						}
					},
					usersAll{
						id
						name
						email
					}
				}`,
				variables: {
					page: this.pagination.page,
					first: this.pagination.length,
					search: this.filters.search,
					type: this.filters.type,
					dates: this.filters.dates,
					user: this.filters.user,
				},
				fetchPolicy: 'no-cache'
			})
			.then((data) => {
				this.list = data.data.controls.data;
				this.pagination.total = data.data.controls.paginatorInfo.total;
				this.users = data.data.usersAll;
				this.loading = false
			});
		},
		openPreview(id){
			this.$refs.controlPreview.open(id)
		},

	}
}


</script>

<style>

</style>
